import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import CtaSection from '../../components/CtaSection/CtaSection';
import MapSection from '../../components/MapSection/MapSection';
import FooterS2 from '../../components/FooterS2/FooterS2';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Services from '../../api/Services';
import IntroImage from '../../images/service/3.jpg';
import Logo from '../../images/logo.png'
const ServicePage = () => {
    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'International Logistics'} pagesub={'Services'} />

            <section className='service-page-intro section-padding'>
              <div className='container'>
                <div className='row align-items-center g-4'>
                  <div className='col-lg-6'>
                    <div className='wpo-section-title'>
                      <h2>Service Overview</h2>
                      <h3>Freight, routing, and handling built around your shipment</h3>
                    </div>
                    <p>
                      Ferry Gold Shipping handles road, air, ocean, and
                      warehousing requirements with a focus on clear execution
                      and dependable movement. Each service is arranged to keep
                      cargo moving with minimal friction from pickup to delivery.
                    </p>
                    <div className='intro-points'>
                      <span>Road Freight</span>
                      <span>Air Freight</span>
                      <span>Ocean Freight</span>
                      <span>Warehousing</span>
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='intro-image-wrap'>
                      <img src={IntroImage} alt='Freight logistics operations' />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className='service-page-tiles section-padding pt-0'>
              <div className='container'>
                <div className='row'>
                  <div className='col-12'>
                    <div className='wpo-section-title'>
                      <h2>Service Categories</h2>
                      <h3>Our core logistics services</h3>
                    </div>
                  </div>
                </div>

                <div className='row g-4'>
                  {Services.map((service) => (
                    <div className='col-xl-3 col-lg-4 col-md-6 col-12' key={service.id}>
                      <div className='service-tile-card'>
                        <img src={service.image} alt={service.title} />
                        <div className='service-tile-content'>
                          <i className={service.iconName}></i>
                          <h3>
                            <Link
                              to={`/services/${service.slug}`}
                              onClick={ClickHandler}
                            >
                              {service.title}
                            </Link>
                          </h3>
                          <p>{service.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <MapSection />
            <CtaSection hclass={'wpo-cta-section-s2'} />
            <FooterS2 />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
